











































































































































































import Vue from 'vue';
export default {
    props: ['item', 'index'],
    data() {
        return {
            images: [
                '.ani',
                '.bmp',
                '.cal',
                '.fax',
                '.gif',
                '.img',
                '.jpg',
                '.jpe',
                '.jpeg',
                '.jpg',
                '.mac',
                '.pbm',
                '.pcd',
                '.pcx',
                '.pct',
                '.pgm',
                '.png',
                '.ppm',
                '.psd',
                '.ras',
                '.tga',
                '.tif',
                '.tiff',
                '.wmf',
                'image/ani',
                'image/bmp',
                'image/cal',
                'image/fax',
                'image/gif',
                'image/img',
                'image/jpeg',
                'image/mac',
                'image/pbm',
                'image/pcd',
                'image/pcx',
                'image/png',
                'image/tga',
                'image/tiff',
                'image/wmf',
                'image/ppm',
                'image/ppm',
                'image/psd',
                'image/ras',
            ],
            pdfs:['.pdf'],
            audios: ['.wav', 'audio/wave'],
            videos: ['.mp4'],
            dialog: false,
            attUri: '',
        };
    },
    methods: {
        getFileType(url, message) {
            let fileType = '';
            if (url) {
                const index = url.lastIndexOf('.');
                const format = url.substring(index, url.length);
                if (format) {
                    const extArray = format.split('?');
                    const actualExt = extArray.length > 1 ? extArray[0] : '';
                    if (this.images.indexOf(actualExt) > -1) {
                        fileType = 'image';
                    }
                    if (this.pdfs.indexOf(actualExt) > -1) {
                        fileType = 'pdf';
                    }
                    if (this.audios.indexOf(actualExt) > -1) {
                        fileType = 'audio';
                    }
                    if (this.videos.indexOf(actualExt) > -1) {
                        fileType = 'video';
                    }
                }
            }
            return fileType;
        },
        getMediaUrl(id, message) {
            const viewUrl = `/attachment/view?id=${id}`;
            return viewUrl;
        },
        getTime(message) {
            return this.$moment(message.createdAt).format('lll');
        },
        mediaLoad(uri) {
            this.attUri = uri;
            this.$emit('onmediaload');
        },
        stringAvtar(name) {
            if (!name) {
                return name;
            }
            const splited =
                name.indexOf(',') > -1 ? name.split(',') : name.split(' ');
            let av = '';
            splited.forEach((s) => {
                if (s.trim()[0] && av.length < 2) {
                    av += s.trim()[0];
                }
            });
            return av;
        },
        updateMessage(message) {
            this.$emit('updateMessage', message);
        },
        joinVideoCall(val) {
            this.$emit('join-video-call', val);
        },
    },
};
